// extracted by mini-css-extract-plugin
module.exports = {"tag":"home_tag__8eYdd"};